import { render, staticRenderFns } from "./UserPayerAdd.vue?vue&type=template&id=5d4d7e44&scoped=true"
import script from "./UserPayerAdd.vue?vue&type=script&lang=js"
export * from "./UserPayerAdd.vue?vue&type=script&lang=js"
import style0 from "./UserPayerAdd.vue?vue&type=style&index=0&id=5d4d7e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d7e44",
  null
  
)

export default component.exports